import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import RealtimeSection from './components/RealtimeSection';
import RankingSection from './components/RankingSection';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <Navbar />
      <main className="bg-background-50 pb-4">
        <h1 className="sr-only">最快吃瓜 - 第一手消息独家速递，实时追踪娱乐热点与独家爆料</h1>

        <Hero />
        <RealtimeSection />
        <RankingSection />
        <CategorySection />
        <AboutSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />

      {/* back to top */}
      {showTop && (
        <a
          href="#home-top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shadow-soft hover:bg-primary-600 transition animate-fade-up"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </a>
      )}

      {/* structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                name: '最快吃瓜',
                url: 'https://srrsbx.cn/',
                slogan: '第一手消息 · 独家速递',
                description: '全网滚动追踪娱乐热点、独家速递爆料的娱乐资讯门户。',
              },
              {
                '@type': 'WebSite',
                name: '最快吃瓜',
                url: 'https://srrsbx.cn/',
                inLanguage: 'zh-CN',
              },
              {
                '@type': 'WebPage',
                name: '最快吃瓜 - 第一手消息 独家速递',
                url: 'https://srrsbx.cn/',
              },
            ],
          }),
        }}
      />
    </>
  );
}